import { useEffect } from "react";
import type { APIGamePreferences } from "@rosette/ts/src/business/api/api_schema.js";
import type { GameSource } from "@rosette/ts/src/business/game/controller/source/GameSource.js";
import type { GameClientControls } from "@rosette/ts/src/business/GameClientControls.js";


export function useSyncGameSource(
    gameSource: GameSource | null,
    clientControls: GameClientControls,
    preferences: APIGamePreferences,
    savedPreferences: APIGamePreferences | null,
): void {
    const gamePreferences = savedPreferences ?? preferences;
    useEffect(() => {
        if (gameSource) {
            gameSource.clientControls.set(clientControls);
            gameSource.updatePreferences(gamePreferences);
        }
    }, [gameSource, clientControls, gamePreferences]);
}
